<template>
  <form class=" mt-2 row g-3 align-items-baseline" v-if="model">
    
    <div class="form-group col-md-12">
      <i class="fa-sharp fa-light fa-lg fa-droplet text-success"></i>
      <span class="ms-2 dx-field-item-label-text text-success">{{ $t('borradores-operacion.form.borrador_agua_titulo') }}</span>
    </div>
    <div v-if="model?.FechaBaja" class="form-group col-md-2">
      <label class="dx-field-item-label-text" for="inputFechaBaja">{{ $t('borradores-operacion.form.fecha_baja') }}</label>
      <div class="mt-1" id="inputFechaBaja">{{ fechaBaja }}</div>
    </div>
    <div v-if="model?.MotivoBaja" class="form-group col-md-10">
      <label class="dx-field-item-label-text" for="inputMotivoBaja">{{ $t('borradores-operacion.form.motivo_baja') }}</label>
      <div class="mt-1" id="inputMotivoBaja">{{ model?.MotivoBaja }}</div>
    </div>
    <div class="form-group col-md-12">
      <label class="dx-field-item-label-text" for="inputDireccionInmueble">{{ $t('borradores-operacion.form.direccion_inmueble') }}</label>
      <div class="mt-1" id="inputDireccionInmueble">{{ model?.DireccionInmueble.DireccionCompleta }}</div>
    </div>
    <div class="form-group col-md-4">
      <label class="dx-field-item-label-text" for="inputTipoTramite">{{ $t('borradores-operacion.form.tipo_tramite') }}</label>
      <div class="mt-1" id="inputTipoTramite">{{ translateEnum(TipoTramiteOperacionEnum, model?.TipoTramite) }}</div>
    </div>
    <div class="form-group col-md-4">
      <label class="dx-field-item-label-text" for="inputIban">{{ $t('borradores-operacion.form.iban') }}</label>
      <div class="mt-1" id="inputIban">{{ model?.Cliente.IbanPago }}</div>
    </div>
    <div class="form-group col-md-12">
      <div>
        <span class="dx-field-item-label-text text-success">{{ $t('borradores-operacion.form.datos_cliente') }}</span>
      </div>
    </div>
    <div class="form-group col-md-12">
      <label class="dx-field-item-label-text" for="inputNombreCompletoCliente">{{ $t('borradores-operacion.form.nombre_completo_cliente') }}</label>
      <div class="mt-2" id="inputNombreCompletoCliente">{{ model?.Cliente.NombreCompleto }}</div>
    </div>
    <div class="form-group col-md-6">
      <label class="dx-field-item-label-text" for="inputTelefonoMovilCliente">{{ $t('borradores-operacion.form.telefono_movil_cliente') }}</label>
      <div class="mt-2" id="inputTelefonoMovilCliente">{{ model?.Cliente.TelefonoMovil }}</div>
    </div>
    <div class="form-group col-md-6">
      <label class="dx-field-item-label-text" for="inputTelefonoFijoCliente">{{ $t('borradores-operacion.form.telefono_fijo_cliente') }}</label>
      <div class="mt-2" id="inputTelefonoFijoCliente">{{ model?.Cliente.TelefonoFijo }}</div>
    </div>
    <div class="form-group col-md-6">
      <label class="dx-field-item-label-text" for="inputEmailCliente">{{ $t('borradores-operacion.form.email_cliente') }}</label>
      <div class="mt-2" id="inputEmailCliente">{{ model?.Cliente.Email }}</div>
    </div>
    <div class="form-group col-md-6">
      <label class="dx-field-item-label-text" for="inputDocumentoCliente">{{ $t('borradores-operacion.form.documento_cliente') }}</label>
      <div class="mt-2" id="inputDocumentoCliente">{{ model?.Cliente.Documento }}</div>
    </div>
    <div class="form-group col-md-12">
      <label class="dx-field-item-label-text" for="inputObservaciones">{{ $t('borradores-operacion.form.observaciones') }}</label>
      <div class="mt-2" id="inputObservaciones">{{ model?.Observaciones }}</div>
    </div>
  </form>
</template>

<script setup lang="ts">
import { TipoTramiteOperacionEnum, type DetailBorradorOperacionModel } from "@/.shared/.api";
import { translateEnum } from "@/.shared/helpers/enums-helper";
import { computed } from "vue";

const props = defineProps<{
  model: DetailBorradorOperacionModel;
}>();

const fechaBaja = computed(() => {
  return props.model.FechaBaja ? new Date(props.model.FechaBaja).toLocaleDateString('es-ES', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }) : null;
});
</script>

<style lang="scss" scoped>

  div[id^="input"] {
    border-bottom: 1px solid var(--border-default-default);
    padding: 5px 12px;
    background: var(--background-normal-light);
    color: var(--text-default-caption);
    height: 30px;
  }

  #inputObservaciones, #inputMotivoBaja {
    white-space: pre-line;
    height: auto;
    min-height: 60px;
  }
  
  .dx-field-item-label-text {
    white-space: nowrap;
    word-wrap: normal;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  </style>


